import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useAZZKULatestEditionID from "./useAZZKULatestEditionID";

export default function useAZZKUAvailableTerritories( variable_id, relation_id ) {
   const edition_id = useAZZKULatestEditionID();
   return useFetchData({
      APIMethod: API.getAZZKUAvailableTerritories,
      params: [ edition_id, variable_id, relation_id ],
      condition: !!edition_id
   })
}